function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconRadioButton = function SvgIconRadioButton(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), h("g", {
    fill: "none",
    stroke: "#06b4ff",
    strokeWidth: 2,
    "data-name": "Ellipse 12"
  }, h("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), h("circle", {
    cx: 13,
    cy: 13,
    r: 12
  })));
};
export default SvgIconRadioButton;